import React from "react";
import { InvitationTokenContext } from "./InvitationTokenContext.js";

export function useInvitationTokenContext() {
  return React.useContext(InvitationTokenContext);
}
